module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/hero-mobile@1x.56b3778.jpg";